/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectPenaltyDetailsTemplateCommand } from '../../models/delete-project-penalty-details-template-command';
import { DeleteProjectPenaltyDetailsTemplateCommandResult } from '../../models/delete-project-penalty-details-template-command-result';

export interface ApiProjectPenaltiesDetailsTemplateDeleteProjectPenaltyDetailsTemplateDelete$Params {
      body?: DeleteProjectPenaltyDetailsTemplateCommand
}

export function apiProjectPenaltiesDetailsTemplateDeleteProjectPenaltyDetailsTemplateDelete(http: HttpClient, rootUrl: string, params?: ApiProjectPenaltiesDetailsTemplateDeleteProjectPenaltyDetailsTemplateDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectPenaltyDetailsTemplateCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectPenaltiesDetailsTemplateDeleteProjectPenaltyDetailsTemplateDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectPenaltyDetailsTemplateCommandResult>;
    })
  );
}

apiProjectPenaltiesDetailsTemplateDeleteProjectPenaltyDetailsTemplateDelete.PATH = '/api/ProjectPenaltiesDetailsTemplate/DeleteProjectPenaltyDetailsTemplate';
